"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_constants_1 = require("../form-constants");
var attachment_element_1 = require("./attachment-element");
exports.ImmutableAttachmentElement = attachment_element_1.ImmutableAttachmentElement;
var basic_form_element_1 = require("./basic-form-element");
exports.ImmutableBasicFormElement = basic_form_element_1.ImmutableBasicFormElement;
var basic_input_element_1 = require("./basic-input-element");
exports.ImmutableBasicInputElement = basic_input_element_1.ImmutableBasicInputElement;
var date_element_1 = require("./date-element");
exports.ImmutableDateElement = date_element_1.ImmutableDateElement;
var duration_element_1 = require("./duration-element");
exports.ImmutableDurationElement = duration_element_1.ImmutableDurationElement;
var electronic_signature_element_1 = require("./electronic-signature-element");
exports.ImmutableElectronicSignatureElement = electronic_signature_element_1.ImmutableElectronicSignatureElement;
var group_element_1 = require("./group-element");
exports.ImmutableGroupElement = group_element_1.ImmutableGroupElement;
var multiple_choice_element_1 = require("./multiple-choice-element");
exports.ImmutableMultipleChoiceElement = multiple_choice_element_1.ImmutableMultipleChoiceElement;
exports.MultipleChoiceOption = multiple_choice_element_1.MultipleChoiceOption;
exports.ImmutableMultipleChoiceOption = multiple_choice_element_1.ImmutableMultipleChoiceOption;
var national_id_element_1 = require("./national-id-element");
exports.ImmutableNationalIdElement = national_id_element_1.ImmutableNationalIdElement;
var numeric_element_1 = require("./numeric-element");
exports.ImmutableNumericElement = numeric_element_1.ImmutableNumericElement;
var postal_code_element_1 = require("./postal-code-element");
exports.ImmutablePostalCodeElement = postal_code_element_1.ImmutablePostalCodeElement;
var text_area_element_1 = require("./text-area-element");
exports.ImmutableTextAreaElement = text_area_element_1.ImmutableTextAreaElement;
var text_element_1 = require("./text-element");
exports.ImmutableTextElement = text_element_1.ImmutableTextElement;
var time_element_1 = require("./time-element");
exports.ImmutableTimeElement = time_element_1.ImmutableTimeElement;
var specialized_text_element_1 = require("./specialized-text-element");
exports.ImmutableSpecializedTextElement = specialized_text_element_1.ImmutableSpecializedTextElement;
var giscoordinates_element_1 = require("./giscoordinates-element");
exports.ImmutableGISCoordinatesElement = giscoordinates_element_1.ImmutableGISCoordinatesElement;
var required_definition_1 = require("./required-definition");
exports.convertRequiredDefinitionToImmutable = required_definition_1.convertToImmutable;
exports.ImmutableBasicRequiredDefinition = required_definition_1.ImmutableBasicRequiredDefinition;
exports.ImmutableSomeRequiredDefinition = required_definition_1.ImmutableSomeRequiredDefinition;
var data_format_1 = require("./data-format");
exports.convertDataFormatToImmutable = data_format_1.convertToImmutable;
exports.ImmutableBasicDataFormat = data_format_1.ImmutableBasicDataFormat;
exports.ImmutableMCOtherFormat = data_format_1.ImmutableMCOtherFormat;
exports.ImmutableZipExtensionFormat = data_format_1.ImmutableZipExtensionFormat;
/**
 * Converts a non-immutable element definition to an immutable element definition that can be used by the form state
 * @param element non-immutable element to be converted
 */
function convertToImmutable(element) {
    switch (element.type) {
        case form_constants_1.elementTypes.attachment: return new attachment_element_1.ImmutableAttachmentElement(element);
        case form_constants_1.elementTypes.heading:
        case form_constants_1.elementTypes.help:
        case form_constants_1.elementTypes.html:
        case form_constants_1.elementTypes.ignore:
        case form_constants_1.elementTypes.page:
        case form_constants_1.elementTypes.undefined:
        case form_constants_1.elementTypes.unsupported:
            return new basic_form_element_1.ImmutableBasicFormElement(element);
        case form_constants_1.elementTypes.email:
        case form_constants_1.elementTypes.phone:
        case form_constants_1.elementTypes.emailNotification:
            return new basic_input_element_1.ImmutableBasicInputElement(element);
        case form_constants_1.elementTypes.date: return new date_element_1.ImmutableDateElement(element);
        case form_constants_1.elementTypes.duration: return new duration_element_1.ImmutableDurationElement(element);
        case form_constants_1.elementTypes.electronicSignature: return new electronic_signature_element_1.ImmutableElectronicSignatureElement(element);
        case form_constants_1.elementTypes.group: return new group_element_1.ImmutableGroupElement(element);
        case form_constants_1.elementTypes.radio:
        case form_constants_1.elementTypes.checkbox:
        case form_constants_1.elementTypes.select:
        case form_constants_1.elementTypes.likert:
            return new multiple_choice_element_1.ImmutableMultipleChoiceElement(element);
        case form_constants_1.elementTypes.nationalId: return new national_id_element_1.ImmutableNationalIdElement(element);
        case form_constants_1.elementTypes.number: return new numeric_element_1.ImmutableNumericElement(element);
        case form_constants_1.elementTypes.postalCode: return new postal_code_element_1.ImmutablePostalCodeElement(element);
        case form_constants_1.elementTypes.specialText: return new specialized_text_element_1.ImmutableSpecializedTextElement(element);
        case form_constants_1.elementTypes.textArea: return new text_area_element_1.ImmutableTextAreaElement(element);
        case form_constants_1.elementTypes.text: return new text_element_1.ImmutableTextElement(element);
        case form_constants_1.elementTypes.time: return new time_element_1.ImmutableTimeElement(element);
        case form_constants_1.elementTypes.gisCoordinates: return new giscoordinates_element_1.ImmutableGISCoordinatesElement(element);
        default: return null;
    }
}
exports.convertToImmutable = convertToImmutable;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-elements/index.js
// module id = 1119
// module chunks = 0